<template>
  <div class="map_container">
    <div class="map_shade"></div>
    <div id="map-container"></div>
  </div>
</template>

<script>
import { default as mapApp } from '@/map/init'

export default {
  name: 'MapIndex',
  data () {
    return {}
  },
  created () { },
  destroyed () { },
  mounted () {
    mapApp.judgeMapParam()
    // 初始化地图
    mapApp.initMap()

    window.mapApp = mapApp
  },
  methods: {}
}
</script>

<style lang="scss">
.map_shade {
  position: absolute;
  box-shadow: inset 0 0 120px 50px #112e2e;
  pointer-events: none;
  width: 100%;
  height: 100%;
  z-index: 2;
}

#map-container {
  position: absolute;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 768px) {
  .map_shade {
    box-shadow: inset 0 0 80px 40px #000000;
  }
}
</style>
